import * as React from "react";
const SvgBearbeiten = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props} aria-label="Bearbeiten">
    <path
      fill="currentColor"
      d="M187.33 207.32H57.73c-4.14 0-7.5-3.36-7.5-7.5V70.23c0-4.14 3.36-7.5 7.5-7.5h57.3c4.14 0 7.5-3.36 7.5-7.5s-3.36-7.5-7.5-7.5H52.2c-9.37 0-16.97 7.6-16.97 16.97v140.65c0 9.37 7.6 16.97 16.97 16.97h140.65c9.37 0 16.97-7.6 16.97-16.97v-62.83c0-4.14-3.36-7.5-7.5-7.5s-7.5 3.36-7.5 7.5v57.3c0 4.14-3.36 7.5-7.5 7.5Z"
    />
    <path
      fill="currentColor"
      d="m108.93 167.1 32-5.02c2.73-.43 5.25-1.71 7.2-3.66l75.94-75.94c5.1-5.1 5.1-13.36 0-18.45L197.1 37.06c-5.1-5.1-13.36-5.1-18.45 0L102.71 113a13 13 0 0 0-3.66 7.2l-5.02 32c-1.37 8.74 6.17 16.29 14.91 14.91Zm78.94-118.06 24.21 24.21-67.25 67.25-24.21-24.21zm-75.12 80.58 18.75 18.75-22.24 3.49z"
    />
  </svg>
);
export default SvgBearbeiten;
